import axios from 'axios';
import { createAsyncThunk, isFulfilled, isPending, isRejected } from '@reduxjs/toolkit';
import { cleanEntity } from 'app/shared/util/entity-utils';
import { IQueryParams, createEntitySlice, EntityState, serializeAxiosError } from 'app/shared/reducers/reducer.utils';
import { IPointDetails, defaultValue } from 'app/shared/model/point-details.model';

const initialState: EntityState<IPointDetails> = {
  loading: false,
  errorMessage: null,
  entities: [],
  entity: defaultValue,
  updating: false,
  totalItems: 0,
  updateSuccess: false,
};
export interface IQueryParamsWithStatus {
  page?: number;
  size?: number;
  sort?: string;
  status?: string;
  categoryId?: number;
}

const apiUrl = 'api/getEarnPointPdfInfo';
const adminApiUrl = 'api/admin/getAllEarnPointPdfInfo';

export const getDocuments = createAsyncThunk(
  'viewDocuments/fetch_entity_list',
  async ({ page, size, sort, status, categoryId }: IQueryParamsWithStatus) => {
    const requestUrl = `${apiUrl}?status=${status}&page=${page}&size=${size}&categoryId=${categoryId}`;
    return axios.get<IPointDetails[]>(requestUrl);
  }
);

export const getAdminDocuments = createAsyncThunk(
  'viewDocuments/fetch_entity_list',
  async ({ page, size, sort, status, categoryId }: IQueryParamsWithStatus) => {
    // &categoryId=${categoryId}

    let requestUrl = `${adminApiUrl}?page=${page}&size=${size}&sort=${sort}&status=${status}`;
    if (categoryId !== null && categoryId !== undefined) {
      requestUrl += `&categoryId=${categoryId}`;
    }

    return axios.get<IPointDetails[]>(requestUrl);
  }
);

export const ViewDocumentsSlice = createEntitySlice({
  name: 'viewDocuments',
  initialState,
  extraReducers(builder) {
    builder
      .addMatcher(isFulfilled(getDocuments, getAdminDocuments), (state, action) => {
        const { data, headers } = action.payload;
        return {
          ...state,
          loading: false,
          entities: data,
          totalItems: parseInt(headers['x-total-count'], 10),
        };
      })
      .addMatcher(isPending(getDocuments, getAdminDocuments), state => {
        state.errorMessage = null;
        state.updateSuccess = false;
        state.loading = true;
      });
  },
});

export const { reset } = ViewDocumentsSlice.actions;

// Reducer
export default ViewDocumentsSlice.reducer;
